var React = require('react');

function CardCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.0761 16.5372H3.6764C2.51662 16.5372 1.57643 15.5971 1.5764 14.4373L1.57617 6.56246C1.57614 5.40264 2.51635 4.4624 3.67617 4.4624H16.2757C17.4355 4.4624 18.3757 5.40206 18.3757 6.56189L18.3758 10.2374M15.2258 14.4224L16.5458 15.7424L19.4258 12.8623M2.10077 8.13727H17.8508","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

CardCheck.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = CardCheck;

CardCheck.default = CardCheck;
